// Code for showing Standings
import { Component } from 'react';
import { savedUsername, fetchApi, buildLinkUrl, subscribeToMasterBallotUpdates } from './utils';
import { Link } from 'react-router-dom';
import './Standings.css';

const STANDINGS_URL = 'standings';

type StandingsProps = {
  username?: string,
}

type Entry = { user: string, points: number }

type StandingsState = {
  show?: string,
  response?: any,
  error?: string,
  username?: string,
  standings: Entry[],
}

export default class Standings extends Component<StandingsProps, StandingsState> {
  
  private unsubscribe?: () => void;
  private currentShow?: string;

  state: StandingsState = { standings: []};

  componentDidMount() {
    document.title = 'Awards Site : Standings';
    this.refreshStandings();

    // Listen for master ballot updates
    this.unsubscribe = subscribeToMasterBallotUpdates((data) => {
      if (data.show_id === this.currentShow) {
        // Refetch the standings to get updated scores
        this.refreshStandings();
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  refreshStandings() {
    const cookieUsername = savedUsername();

    var url = STANDINGS_URL;
    fetchApi(url)
      .then((responseJson) => {
        // Store the current show for use in event handlers
        this.currentShow = responseJson.show_id;
        const standings = []
        for (const user of responseJson.standings) {
          standings.push({user: user.username, 
            points: user.points});
        }
        this.setState({
	        username: cookieUsername,
          response: responseJson,
          show: responseJson.show_id,
          standings: standings
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ error: error.message });
      });
  }
  
  StandingsGraph = (): JSX.Element => {
    return <div id="page">
      <div id="standings">
        <ul className="graph">
          {this.state.standings.map((entry: Entry) => {
            var user = entry.user;
            var usernameDisplay = user;
            var website = false;
            const websiteRegex = /^(Magazine|Website): */;
            if (user.match(websiteRegex)) {
              website = true;
              usernameDisplay = user.replace(websiteRegex, '');
            }
            const classes = 'entry ' + (user === this.state.username ? "highlight" : (website ? "website" : ""));
            const userdataUrl = '/table/user/' + user;
            return (<li key={user} className={classes}>
              <Link className="name"
                to={buildLinkUrl(userdataUrl)}
              >{usernameDisplay}</Link>
              <span className={`points ${entry.points === 0 ? 'is-zero' : ''}`}
                style={{ '--bar-length': `${entry.points}ch` } as React.CSSProperties}>
                {entry.points}
              </span>
            </li>
          );})}
        </ul>
      </div>
      <div className="fineprint">
          Questions, complaints, death threats, etc. should be emailed
          to <a href="mailto:portnoy@portnoy.org">portnoy@portnoy.org</a>.
      </div>
    </div>;
  };

  render() {
    if (this.state.error) {
      return <div className="error-message">Could not load standings: {this.state.error}</div>
    }
    if (this.state.response == null) {
      return <div>Loading...</div>
    }
    const date = new Date(this.state.response.show_date);
    const formatter = Intl.DateTimeFormat("default", { weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZoneName: 'short'});

    return <div className='page'>
      <Header title={this.state.response.show_title + ' Standings'} 
subtitle={'Awards broadcast is ' + formatter.format(date) + '.  ' + this.state.response.notes} />
      <this.StandingsGraph />
    </div>
  }
}

function Header(props: {title: string, subtitle?: string}) {
  return <div id="header">
    <h1>{props.title}</h1>
    <div role="doc-subtitle">{props.subtitle}</div>
  </div>
}
